import React, { Component } from 'react';
import styled from 'styled-components';
import Placeholder from '../../components/molecule/Placeholder';
import CardGrid from '../../components/organism/CardGrid';
import * as Constants from '../../core/constants';
import InfoCard from '../../components/molecule/Cards/InfoCard';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getClassLibrary, isLibraryLoading, draftsLoaded, classQuery, classBase } from '../../modules/Class';
import searchController from '../../components/hoc/searchController';
import SearchBar from '../../components/organism/SearchBar';
import { getResources } from '../../modules/Resource';
import { createSelects, displayTags, minToHHMMSS } from '../../utils';
import { toast } from 'react-toastify';


const ENT_PLACEHOLDER = require('../../assets/entity_placeholder.jpg').default;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  // height: 100%;
`
const CardGridStyled = styled(CardGrid)`

`
const Scrollable = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-bottom: 115px;
`

const PlaceholderStyled = styled(Placeholder)`
  margin: 100px auto;
`

const ClassSearch = searchController(SearchBar, 'classes', { params: { page: Constants.START_PAGE_DEFAULT, page_size: Constants.PER_PAGE_DEFAULT, filter: 'drafts' } });

class ClassLibrary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: Constants.START_PAGE_DEFAULT,
      perPage: Constants.PER_PAGE_DEFAULT,
      gotoNext: false,
    };
  }

  async componentDidMount() {
    const { getResources, resourceState, getClassLibrary, classBase } = this.props;
    const { page, perPage } = this.state;

    try {
      if(!resourceState.resourceData){
        await getResources();
      }

      classBase();
      await getClassLibrary({ params: { page, page_size: perPage, filter: 'drafts' } }, 'drafts');
    } catch(e) {
      toast.error(e.message); 
    }
  }

  renderCard = (item, index) => {
    const { history, resourceState } = this.props;
    return (
      <InfoCard
        key={`${index}-${item.title}`}
        image={item.image ? item.image.url : ENT_PLACEHOLDER}
        header={item.title}
        premium={item.premium_required}
        subtext1={displayTags(item.tags)}
        subtext2={minToHHMMSS(item.duration)}
        chips={item.categories}
        level={item.intensity_level}
        levels={resourceState.resourceData.intensity_level}
        onClick={() => history.push(`/classes/${item.id}`, { data: item })}
      />
    )
  }

  onNext = () => {
    const { classState } = this.props;
    const { totalCount, draftClasses } = classState;
    if (draftClasses && totalCount && draftClasses.length < totalCount && !classState.isLoading) {
      this.setState({gotoNext: true})
    }
  }

  libraryDidLoad = (results, count, query) => {
    this.props.draftsLoaded(results, count, query);
    this.setState({gotoNext: false});
  }

  startQuery = () => {
    const { classQuery, classState } = this.props;
    if(!classState.isLoading) {
      classQuery();
    }
  }

  render() {
    const { resourceState, classState, isLibraryLoading, modalComponent, authState: {userData} } = this.props;
    const { perPage, gotoNext } = this.state;
    const isAdmin = userData?.is_superuser;

    const includedSelects = {
      cat: true,
      mg: true,
      il: true,
      eq: false,
      fg: false,
      tr: isAdmin
    };

    return (
      <Container>
        <ClassSearch
          selects={createSelects(resourceState.resourceData, undefined, includedSelects)}
          getter={isLibraryLoading}
          setter={this.libraryDidLoad}
          base={this.startQuery}
          gotoNext={gotoNext}
          perPage={perPage}
        />
        <Scrollable>
          {
            (
              classState.draftClasses.length <= 0 &&
              !classState.isLoading &&
              classState.query === ''
            ) ? (
              <PlaceholderStyled
                title="No Classes Found"
                subtext={[
                  'To create a class',
                  'Click below'
                ]}
                modalComponent={modalComponent}
                buttonIcon='add'
                buttonText='create class'
              />
            ) : (
              <CardGridStyled
                data={classState.draftClasses}
                renderItem={(item,index) => this.renderCard(item,index)}
                nextPage={this.onNext}
                isLoading={classState.isLoading}
              />
            ) 
          }
        </Scrollable>
      </Container>
    )
  }
}

ClassLibrary.propTypes = {
};

ClassLibrary.defaultProps = {
};

function mapStateToProps(state) {
  return {
    authState: state.authState,
    resourceState: state.resourceState,
    classState: state.classState
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getResources: getResources,
    getClassLibrary: getClassLibrary,
    isLibraryLoading: isLibraryLoading,
    draftsLoaded: draftsLoaded,
    classQuery: classQuery,
    classBase: classBase,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ClassLibrary);
